// define the names of all the columns (properties) in a profile's 'extraInfo'
const ColumnNames = {
    memberLastName: "Last Name",
    memberFirstName: "First Name",
    memberGender: "Sex Code",
    memberStatusCode: "Status Code",
    memberStatusDate: "Status Date",
    memberDOB: "Birth Date",
    hireDate: "Hire Date",
    maritalStatus: "Marital Status",
    spouseDOB: "Spouse Birth Date",
    spouseLastName: "Spouse Last Name",
    spouseFirstName: "Spouse First Name",
    spouseGender: "Spouse Sex Code",
    pastServiceCredits: "Past Service Credits",
    futureServiceCredits: "Future Service Credits",
    priorYearsWorked: "Prior Yr Hours",
    currentYearHours: "Current Yr Hours",
    vestingCredits: "Vesting Credits",
    lastYearActive: "Last Year Active",
    accrualRate: "Accrual Rate",
    monthlyBen: "Monthly Ben",
    TotalEmployerContribCurrentYer:
        "Total Employer Contributions - Current Plan Year",
    l697SavingsBalance: "L697 Savings Balance",
    HRASavingsBalance: "HRA Savings Balance",
    planPEligible: "Plan P Eligible",
    planPTotalService: "Plan P Total Service",
    planPBen: "Plan P Ben",
    planPRate: "Plan P Rate",
    planPCyCredit: "Plan P CY Credit",
    NEBFService: "NEBF Service",
    IOEligible: "IO Eligible",
    IOService: "IO Service",
    cyCredit: "CY Credit",
    planPExcessHours: "Plan P Excess Hours",
    pensionExcessHours: "Pension Excess Hours",

    // added 8/19/2022
    eeAfterTax: "EEAfterTax",
    eePreTax: "EEPreTax",
    erContrib: "ERContrib",
    rollover: "Rollover",
    rothDeferral: "RothDeferral",
    savingsCheck: "SavingsCheck",

    // added 01/25/2023
    futureServiceCredits1Max: "Future Service Credits 1-MAX",
    IOServicePost2023: "IO Service-Post2023",
}

export { ColumnNames }



// WEBPACK FOOTER //
// ./src/config/697/ETL/interfaces.ts